import { Injectable, EventEmitter } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {
  Http,
  Response,
  Headers,
  RequestOptions,
  Request
}
  from '@angular/http';
import { Observable, Subject, BehaviorSubject } from 'rxjs/Rx';
import { environment } from '../../../../environments/environment';
// Interfaces
import { IService, DiscussionInterface, IApplication, IPostDisplay, IPostDisplayByUser } from '../../interfaces';

// Services
import { LogService } from '../log/log.service';
import { ServerService } from '../server/server.service';
import { HelperService } from '../helper/helper.service';
import { UserService } from '../user/user.service';
import { StorageService } from '../storage/storage.service';
import { LoaderService } from '../loader/loader.service';


import { ApplicationService } from '../application/application.service';
// Enum
import { DiscussionEnum, RoleEnum } from '../../enums';
// Models
import { CRMDiscussion as _CRM } from '../../classes';
// Classes
import { KeyedCollection } from '../../classes';

@Injectable()
export class DiscussionService implements IService {
  // implements IService
  name = 'DiscussionService';
  test(name, value) {
    console.log('testing', name, value);
  }

  // implements local variables
  showOnlyAppHistory: boolean = false;
  private _lastPostFilter: IPostDisplay;
  private _lastPostDisplayByUser: IPostDisplayByUser;
  private _posts: BehaviorSubject<_CRM.Post[]> = new BehaviorSubject([]);
  private _discussion: BehaviorSubject<_CRM.CRMDiscussionModel> = new BehaviorSubject(undefined);
  private _discussions: BehaviorSubject<_CRM.CRMDiscussionModel[]> = new BehaviorSubject(undefined);

  private _crm_dataStore: {
    url: string,
    posts: _CRM.Post[],
    discussions: _CRM.CRMDiscussionModel[],
    asApplicant: boolean;
    isChecked: IPostDisplay;
    isCheckedUser: IPostDisplayByUser;
  };
  // public LegendSelected$ = new EventEmitter<{ comment: boolean, update: boolean, status: boolean }>(true);

  public LegendSelected$ = new EventEmitter<{
    Applicant: boolean,
    QC: boolean,
    Panel: boolean,
    Board: boolean
  }>(true);

  constructor(

    private _logSrv: LogService,
    private _userSrv: UserService,
    private _serverSrv: ServerService,
    private _helperSrv: HelperService,
    private _storageSrv: StorageService,
    private _loaderSrv: LoaderService,

    private _applicationSrv: ApplicationService,
    private _sanitizer: DomSanitizer,

  ) { }

  get Crm_DataStore() {
    return this._crm_dataStore;
  }

  get POSTS() {
    return this._posts.asObservable();
  }

  set Posts(value: _CRM.Post[]) {
    "Updating posts".logWithObject(this.name, value);
    this._posts.next(value);
  }

  get DISCUSSION() {
    return this._discussion.asObservable();
  }

  set Discussion(model: _CRM.CRMDiscussionModel) {
    this._discussion.next(model);
  }

  get DISCUSSIONS() {
    return this._discussions.asObservable();
  }

  set Discussions(models: _CRM.CRMDiscussionModel[]) {
    this._discussions.next(models);
  }

  get Discussions() {
    return this._crm_dataStore.discussions;
  }

  get Comments() {
    console.log('COMMENTS', this._crm_dataStore);
    return this._crm_dataStore.discussions.find(d => d.Type === DiscussionEnum.Type[DiscussionEnum.Type.Comment]);
  }

  get Documents() {
    console.log('DOCUMENTS', this._crm_dataStore);
    return this._crm_dataStore.discussions.find(d => <DiscussionEnum.Type>d.Type === DiscussionEnum.Type.Document);
  }

  get Statues() {
    console.log('STATUSES', this._crm_dataStore);
    return this._crm_dataStore.discussions.find(d => <DiscussionEnum.Type>d.Type === DiscussionEnum.Type.Status);
  }

  /**
    * Create Comment Discussion
    * External
    * */
  CreateComment(
    applicationId: string,
    applicationNumber: string,
    contactId: string,
    comment: string,
    notify?: DiscussionInterface.INotify): DiscussionInterface.IDiscussion {
    if (!notify) {
      notify = {
        Acep: true,
        Applicant: true,
        Board: true,
        Panel: true
      };
    }
    let d = this.CreateDiscussion(
      applicationId,
      applicationNumber,
      contactId,
      comment,
      DiscussionEnum.Location.External,
      DiscussionEnum.Type.Comment,
      notify);
    return d;
  }

  /**
   * Create Document Discussion
   * Internal
   */
  CreateDocument(
    applicationId: string,
    applicationNumber: string,
    contactId: string,
    comment: string,
    notify?: DiscussionInterface.INotify): DiscussionInterface.IDiscussion {
    let d = this.CreateDiscussion(
      applicationId,
      applicationNumber,
      contactId,
      comment,
      DiscussionEnum.Location.Internal,
      DiscussionEnum.Type.Document,
      notify);
    return d;
  }

  /**
  * Create Status Discussion
  * External
  */
  CreateStatus(
    applicationId: string,
    applicationNumber: string,
    contactId: string,
    comment: string,
    notify?: DiscussionInterface.INotify): DiscussionInterface.IDiscussion {
    let d = this.CreateDiscussion(
      applicationId,
      applicationNumber,
      contactId,
      comment,
      DiscussionEnum.Location.External,
      DiscussionEnum.Type.Status,
      notify);
    return d;
  }

  /**
   * Create an IDiscussion
   * @param applicationId
   * @param applicationNumber
   * @param contactId
   * @param comment
   * @param location
   * @param type
   * @param notify
   */
  CreateDiscussion(
    applicationId: string,
    applicationNumber: string,
    contactId: string,
    comment: string,
    location: DiscussionEnum.Location,
    type: DiscussionEnum.Type,
    notify?: DiscussionInterface.INotify): DiscussionInterface.IDiscussion {
    let d: DiscussionInterface.IDiscussion = {
      applicationId: applicationId,
      applicationNumber: applicationNumber,
      comment: comment,
      contactId: contactId,
      location: location,
      notify: notify || {
        Acep: false,
        Applicant: false,
        Panel: false,
        Board: false,
      },
      title: this._applicationSrv.DATA.application.Application.Name,
      type: type
    };
    return d;
  }

  private _updateDiscussion(model: any)
    : Promise<boolean> {
    return new Promise((resolved, failed) => {
      // this._logSrv.Debug(this.name, ['_updateDiscussion', model]);
      let type = model.Type;
      let crmDiscussion = this._crm_dataStore.discussions.find(m => m.Type === type);
      let index = this._crm_dataStore.discussions.indexOf(crmDiscussion);

      // Replace the store discussion model
      this._crm_dataStore.discussions[index] = model;
      this._logSrv.Debug(
        this.name,
        ['_updateDiscussion', { type: type, model: model, crmDiscussion: this._crm_dataStore.discussions.find(m => m.Type === type) }]);
      this._loadDiscussion(model, crmDiscussion);
      this._sortAndFilterPosts();
      this.filter();
      resolved(true);
    });
  }

  private _loadDiscussion(model: any, crmDiscussion: _CRM.CRMDiscussionModel): Promise<boolean> {
    return new Promise((resolve, fail) => {
      this._logSrv.Debug(this.name, ['loading discussion', model, crmDiscussion]);
      // get Discussion
      let d = model.Discussion;

      // this._logSrv.Debug(this.name, ['load discussions d', d]);

      // let disc = this._crm_dataStore.discussions[count];

      crmDiscussion.Attributes = new KeyedCollection<any>();
      crmDiscussion.LogicalName = d.LogicalName;
      // this._logSrv.Debug(this.name, ['load discussions disc', disc]);

      // get Attributes
      d.Attributes.forEach(a => {
        crmDiscussion.Attributes.Add(a.Key, a.Value);
      });

      // get acep_type
      crmDiscussion.Acep_Type =
        crmDiscussion.Attributes.Item('acep_type').Value;

      // get Posts
      model.Posts.forEach(p => {
        let post = this._parsePost(
          p.posting, crmDiscussion.Acep_Type);

        // if post is not undefined
        // add to post collection
        if (post) {
          post.RoleEnum = p.position;
          crmDiscussion.Posts.push(post); // add posts to discussion object
          this._crm_dataStore.posts.push(post); // add posts to Posts object
        }
      });
    });
  }


  private _loadDiscussions(disx: any, isApplicant: boolean): Promise<{
    discussions: _CRM.CRMDiscussionModel[],
    posts: _CRM.Post[]
  }> {
    return new Promise((resolved, failed) => {
      try {
        // this._logSrv.Debug(this.name, ['loading discussions disx', disx]);
        let count = 0;
        this._crm_dataStore = {
          url: disx.url,
          discussions: disx.discussions,
          posts: [],
          asApplicant: isApplicant,
          isChecked: {
            comment: false,
            status: false,
            update: false
          },
          isCheckedUser:
          {
            Applicant: true,
            QC: true,
            Panel: true,
            Board: true
          }
        };

        this._logSrv.Debug(this.name, ['loading datastore', this._crm_dataStore]);
        <Array<any>>disx.discussions.forEach(model => {
          // this._logSrv.Debug(this.name, ['load discussions x', x]);
          // this._logSrv.Debug(this.name, ['load discussions d', d]);

          let crmDiscussion = this._crm_dataStore.discussions[count];

          this._loadDiscussion(model, crmDiscussion).then(result => {
            count++;
          });
        });

        // let crmPosts: _CRM.Post[];

        // sort posts
        //crmPosts =
        this._sortAndFilterPosts();
        // this._logSrv.Debug(this.name, ['posts', crmPosts]);

        // filter posts
        let filters = this._storageSrv.GetSessionObject<IPostDisplay>(this._storageSrv.KEY_DISCUSSION_LEGENDS);
        //<IPostDisplay>this._storageSrv.getSession(this._storageSrv.KEY_DISCUSSION_LEGENDS);
        if (!filters) {
          filters = { comment: true, update: false, status: false };

          this._storageSrv.setSession(this._storageSrv.KEY_DISCUSSION_LEGENDS, filters);

        }

        let filtersUser = this._storageSrv.GetSessionObject<IPostDisplayByUser>(this._storageSrv.KEY_DISCUSSION_LEGENDSUSER);
        if (!filtersUser) {
          filtersUser = {
            Applicant: true,
            QC: true,
            Panel: true,
            Board: true
          };

          this._storageSrv.setSession(this._storageSrv.KEY_DISCUSSION_LEGENDSUSER, filtersUser);
          this.LegendSelected$.emit(filtersUser);
        }

        this.filter(filters, filtersUser);
        //this._logSrv.Debug(this.name, [filters, this._crm_dataStore]);

        resolved({ discussions: this._crm_dataStore.discussions, posts: this._crm_dataStore.posts });
      } catch (err) {
        failed(err);
      }
    });

    // END PROMISE
  }

  private _sortAndFilterPosts(): _CRM.Post[] {
    this._crm_dataStore.posts.sort((p1, p2) => {
      if (p1.CreatedOn < p2.CreatedOn) {
        return 1;
      } else if (p1.CreatedOn === p2.CreatedOn) {
        return 0;
      } else {
        return -1;
      }
    });

    if (this._crm_dataStore.asApplicant) {
      this._crm_dataStore.posts = this._crm_dataStore.posts.filter(p => p.Location !== DiscussionEnum.Location);
    };
    return this._crm_dataStore.posts;
  }

  /**
   * Parses entity attributes to post object
   * if no comment found, returns undefined
   * @param e
   * @param acep_type
   */
  private _parsePost(e: any, acep_type: string) {
    let post = new _CRM.Post();
    post.Attributes = new KeyedCollection<any>();
    e.Attributes.forEach(x => {
      post.Attributes.Add(x.Key, x.Value);
    });
    let value = post.Attributes.Item('acep_comments');
    if (value === undefined) {
      return undefined;
    } else {
      post.LogicalName = e.LogicalName;
      post.Audience = post.Attributes.Item('acep_audience').Value;
      post.Acep_Type = acep_type;
      post.Name = post.Attributes.Item('acep_contact');
      post.CreatedOn = new Date(post.Attributes.Item('createdon'));
      post.Body = this._sanitizer.bypassSecurityTrustHtml(post.Attributes.Item('acep_comments'));
      return post;
    }
  }

  filter(isChecked?: IPostDisplay, isCheckedUser?: IPostDisplayByUser): _CRM.Post[] {
    if (isChecked) {
      this._lastPostFilter = isChecked;
    } else if (this._lastPostFilter) {
      isChecked = this._lastPostFilter;
    } else {
      isChecked = {
        comment: true,
        status: false,
        update: false
      };
    }


    if (isCheckedUser) {
      this._lastPostDisplayByUser = isCheckedUser;
    } else if (this._lastPostDisplayByUser) {
      isCheckedUser = this._lastPostDisplayByUser;
    } else {
      isCheckedUser = {
        Applicant: true,
        QC: true,
        Panel: true,
        Board: true
      };
    }


    this._crm_dataStore.isChecked = isChecked;
    this._crm_dataStore.isCheckedUser = isCheckedUser;

    let posts: _CRM.Post[];
    let discussionTypes: string[] = [];
    let type: string;
    if (isChecked.comment) { discussionTypes.push(DiscussionEnum.Type.Comment.toFixed()); type = 'Comment' }
    if (isChecked.update) { discussionTypes.push(DiscussionEnum.Type.Document.toFixed()); type = 'Document' }
    if (isChecked.status) { discussionTypes.push(DiscussionEnum.Type.Status.toFixed()); type = 'Status' }


    if (discussionTypes.length > 0) {
      posts = this._crm_dataStore.posts.filter(p => discussionTypes.some(i => i === String(p.Acep_Type).trim()));

      //Filter by roles only if comments tab - and NOT History Tab
      if (!this.showOnlyAppHistory) {

        let allowedRoles = [];
        if (isCheckedUser.Applicant) {
          allowedRoles.push(RoleEnum.Applicant);
        }
        if (isCheckedUser.QC) {
          allowedRoles.push(RoleEnum.QC);
        }
        if (isCheckedUser.Panel) {
          allowedRoles.push(RoleEnum.Panel);
        }
        
        if (isCheckedUser.Board) {
          allowedRoles.push(RoleEnum.Board);
        }

        posts = posts.filter(p => allowedRoles.indexOf(+p.RoleEnum) > -1);
      }
      // if we are selecting only one discussion type and not all
      // set Discussion observable to that discussion model
      // else set it to undefined
      let crmDiscussion = this._crm_dataStore.discussions.find(m => m.Type === type);
      if (crmDiscussion) {
        this.Discussion = crmDiscussion;
      } else {
        this.Discussion = undefined;
      }
    } else {
      this.Discussion = undefined;
    }


    this._logSrv.Debug(this.name, ['filter', isChecked, discussionTypes, posts, type, this._crm_dataStore]);
    this.Discussions = this._crm_dataStore.discussions;
    this.Posts = posts;
    return posts;
  }

  page(url: string, isChecked: IPostDisplay, ) {
    // get posts

  }

  add(
    endPoint: string
  ): Observable<any> {
    this._logSrv.Debug(
      this.name, ['update Discussion store ', this._crm_dataStore]);

    //var isChecked = this._crm_dataStore.isChecked

    return this._serverSrv.GetWithAuth(this._userSrv.Data.contact.AcepId, endPoint)
      .map(m => m.json())
      .do(model => {
        // `getting discussion ${isChecked}`.logWithObject(this.name, model);
        this._updateDiscussion(model.Data.discussions[0]);
      })
      .catch(this.handleError);
  }

  get(
    applicaitonid: string,
    audience: DiscussionEnum.Location,
    isApplicant: boolean): Observable<any> {
    this._logSrv.Debug(
      this.name, ['post', 'Discussion:', applicaitonid]);

    if (isApplicant) {
      audience = DiscussionEnum.Location.External;
    }

    let endPoint =
      environment.APILocation + 'discussion/applicationid/' + applicaitonid + '/audience/' + audience.toFixed() + '/page/1';

    return this._serverSrv.GetWithAuth(this._userSrv.Data.contact.AcepId, endPoint)
      .map(m => m.json())
      .do(model => {
        'getting discussions'.logWithObject(this.name, model);
        this._loadDiscussions(
          model.Data, isApplicant)
          .then(dis => {
            this._logSrv.Debug(this.name, ['discussions are loaded ']);
          }, failed => {
            this._logSrv.Error(this.name, ['Unable to load discussion posts', failed]);
          });
      });
    // .catch(this.handleError);
  }

  post(
    discussion: DiscussionInterface.IDiscussion,
    isApplicant: boolean,
    update?: boolean,
    external?: boolean
  ): Observable<any> {
    this._logSrv.Debug(
      this.name, ['post', 'Discussion:', discussion]);

    let body = {
      applicationId: discussion.applicationId,
      applicationNumber: discussion.applicationNumber,
      contactId: discussion.contactId,
      title: discussion.title,
      comment: discussion.comment,
      notify: discussion.notify,
      acep_type: discussion.type,
      location: discussion.location
    };

    let endPoint =
      environment.APILocation + 'discussion';

    return this._serverSrv.PostWithAuth(this._userSrv.Data.contact.AcepId, endPoint, body)
      //.map(m => JSON.parse(m.json()))
      .do(data => {
        // console.log('JSON', data, discussion.type);

        if (update === true) {
          // push it to local datastore
          if (this._crm_dataStore && this._crm_dataStore.posts) {
            // let x = this._parsePost(data, discussion.type.toFixed());
            let location =
              external
                ? DiscussionEnum.Location.External
                : DiscussionEnum.Location.Internal;

            // create
            this.get(
              discussion.applicationId,
              location,
              isApplicant).subscribe(disx => {
                // this._loadDiscussions(disx, isApplicant);
              });

            // let comments = this.Comments;
            // if (!comments) {
            //   if (external) {
            //     // create
            //     this.get(
            //       discussion.applicationId,
            //       location,
            //       isApplicant).subscribe(disx => {
            //         this._loadDiscussions(disx, isApplicant);
            //       });
            //   }
            // } else {
            //   comments.Posts.push(x);
            //   this._crm_dataStore.posts.push(x);
            //   this._sortAndFilterPosts();
            //   this.filter(undefined);
            //   setTimeout(() => {
            //     this._posts.next(Object.assign({}, this._crm_dataStore).posts);
            //   }, 1000);
            //   'post discussion'.logWithObject(this.name, x);
            // }
          }
        }
      });
    // .catch(this.handleError);
  }

  private handleError(error: Response, caugth: Observable<any>) {
    // console.log(error.json());
    // this.log.Error(this.pageName, [error.json()]);

    // console.log(caugth);
    return Observable.throw(error);
  }

}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/services/discussion/discussion.service.ts